require("./a-btn-more.scss");


// WEBPACK FOOTER //
// ./Sig.Web/src/atomic/atom/a-btn-more/a-btn-more.chunk.js